<template>
    <div class="links_wrapper clearfix">
        <ul class="clearfix fl">
            <img
                class="fl"
                src="https://lian.xiniu.com/Images/index/index_friendLinkImg.png"
                alt=""
            />
            <span class="fl">友情链接：</span>
            <li class="fl" v-for="(item, idx) in linksList" :key="idx" @click="openWrapperUrl(item.url)">
                {{ item.text }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        linksList: {
            type: [Array],
            required: true,
        },
    },
    data() {
        return {};
    },
    methods: {
      openWrapperUrl(url) {
        window.open(url)
      }
    }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/mixin.scss/";
.links_wrapper {
    padding-left: px2rem(20);
    margin-top: px2rem(30);
    .left {
        display: flex;
        align-items: center;
        height: 20px;
        line-height: 20px;
    }
    img {
        width: 19px;
        height: 19px;
    }
    span {
        margin-left: 10px;
        font-size: 16px;
        color: #333;
    }
    li {
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        color: #333;
        padding: 0 px2rem(30);
        border-right: 1px solid #888;
        cursor: pointer;
        transition: 0.3s;
        margin-bottom: 10px;
        &:hover {
            color: #e51624;
        }
        &:last-child {
            border: none;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Phonelinks.vue